import React, { Component } from "react"
import styled from "styled-components"
import { inject, observer } from "mobx-react"
import ReactModal from "react-modal"

import MODAL_STYLES from "~/components/modals/styles"
import Runner from "~/components/loader/Runner"

const Center = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

const Main = styled.div`
  text-align: center;
  font-size: 2em;
  color: ${props => props.theme.colors.text.header};
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  margin: 1em;
`

@inject(all => ({
  isMobile: all.store.ui.isMobile,
  isLoading: all.store.parkingFlow.results.service.isLoading
}))
@observer
class LoadingModal extends Component {
  render() {
    return (
      <ReactModal
        closeTimeoutMS={300}
        isOpen={this.props.isLoading}
        style={
          this.props.isMobile
            ? MODAL_STYLES.mobile.faq
            : MODAL_STYLES.desktop.general
        }
        contentLabel="Searching for tickets."
      >
        <Center>
          <Main>Searching</Main>
          <Runner />
        </Center>
      </ReactModal>
    )
  }
}

export default LoadingModal
